<template>
  <!-- 填空题 -->
  <yxt-form
    ref="ruleForm"
    :model="currentComponent"
    label-width="100px"
    isNeedRequire
    isNeedTooltip
    label-position="top"
  >
    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_questionstem')"
      :rules="rulesContent"
      :prop="'content'"
      size="small"
    >
      <common-attachment-textfield
        :content.sync="currentComponent.content"
        single-limit
      />
    </yxt-form-item>

    <yxt-form-item
      :label="$t('pc_biz_ote_lbl_itemanswer')"
      class="mb24"
      size="small"
    >
      <div class="yxtbiz-ote-edit-ques-kw yxtbiz-ote-edit-ques-kw--fillin">
        <div
          v-for="(item, index2) in currentComponent.itemAnswerObj"
          :key="item.id"
          class="mb8"
        >
          <div class="lh22 mb8">
            {{ $t('pc_biz_ote_lbl_itemanswer') }}
            <span class="min-w-16 d-in-block">{{ index2 + 1 }}</span>
          </div>
          <div class="flex flex-wrap">
            <yxt-form-item
              v-for="(answer, i) in Object.keys(item)"
              :key="'a' + i + Object.keys(item).length"
              :rules="rulesItem(item[answer])"
              :prop="'itemAnswerObj.' + index2 + '.' + answer"
              size="small"
            >
              <div class="flex">
                <yxt-input
                  :ref="'editorItem_input' + index2"
                  v-model="item[answer]"
                  class="width120"
                  maxlength="200"
                  @input="
                    changeValue(
                      currentComponent.itemAnswerObj,
                      index2,
                      answer,
                      $event
                    )
                  "
                ></yxt-input>
                <div class="flex flex-mid">
                  <!-- 删除答案空 -->
                  <yxt-tooltip
                    v-if="Object.keys(item).length > 1"
                    :content="$t('pc_biz_ote_btn_delete')"
                    placement="top"
                  >
                    <div
                      class="yxtbiz-ote-ai-icon hand mh2 color-gray-8"
                      @click="delItemAnswer(index, i, item)"
                    >
                      <yxt-svg
                        width="16px"
                        height="16px"
                        icon-class="minus-circle-o"
                      />
                    </div>
                  </yxt-tooltip>
                  <yxt-tooltip
                    v-if="
                      i === Object.keys(item).length - 1 &&
                      Object.keys(item).length < 6
                    "
                    :content="$t('pc_biz_ote_tip_alternativeanswertip')"
                    placement="top"
                  >
                    <div
                      class="yxtbiz-ote-ai-icon hand mh2 color-gray-8"
                      @click="addItemAnswer(index, i, item)"
                    >
                      <yxt-svg
                        width="16px"
                        height="16px"
                        icon-class="plus-circle-o"
                      />
                    </div>
                  </yxt-tooltip>
                </div>
              </div>
            </yxt-form-item>
            <div class="flex flex-mid height32">
              <yxt-tooltip
                :content="$t('pc_biz_ote_btn_delete')"
                placement="top"
              >
                <div
                  class="yxtbiz-ote-ai-icon hand mh2 color-gray-8"
                  @click="delItem(index2)"
                >
                  <yxt-svg width="16px" height="16px" icon-class="delete" />
                </div>
              </yxt-tooltip>
            </div>
          </div>
        </div>
        <!-- 添加选项 -->
        <div class="mt8 lh22">
          <yxt-button
            type="text"
            @click="addItem()"
            :disabled="
              currentComponent.itemAnswerObj &&
              currentComponent.itemAnswerObj.length >= 12
            "
          >
            <div class="flex flex-mid">
              <yxt-svg
                width="16px"
                height="16px"
                class="mr4"
                icon-class="common_plus"
              ></yxt-svg>
              <span>{{ $t('pc_biz_ote_btn_newanswer') }}</span>
            </div>
          </yxt-button>
        </div>
        <yxt-checkbox
          class="mt16"
          v-model="currentComponent.noOrderMark"
          :true-label="1"
          :false-label="0"
          >{{ $t('pc_biz_ote_lbl_answersmultipleorder') }}</yxt-checkbox
        >
      </div>
    </yxt-form-item>

    <yxt-form-item :label="$t('pc_biz_ote_lbl_quesanalyze')" size="small">
      <common-attachment-textfield
        :content.sync="currentComponent.explainText"
        single-limit
      />
    </yxt-form-item>
  </yxt-form>
</template>

<script>
import { quesMixin } from './quesMixin';
import CommonAttachmentTextfield from './components/CommonAttachmentTextfield.vue';
import { getSafeHtmlContent } from '../../utils';
export default {
  name: 'quesCompletion',
  mixins: [quesMixin],
  components: {
    CommonAttachmentTextfield
  },
  data() {
    return {
      rulesContent: {
        required: true,
        message: this.$t('pc_biz_ote_msg_pleaseenterquestion'),
        trigger: 'blur'
      },
      rulesAnswer: {
        required: true,
        message: this.$t('pc_biz_ote_msg_itemanswer'),
        trigger: 'blur'
      }
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    rulesItem(val) {
      return {
        required: true,
        message: this.$t('pc_biz_ote_msg_itemanswer'),
        trigger: 'blur',
        validator: (rule, value, callback) => {
          if (!val) {
            callback(new Error(this.$t('pc_biz_ote_msg_itemanswer')));
            return;
          }
          callback();
        }
      };
    },
    changeValue() {
      this.$forceUpdate();
    },
    // 增加一个
    addItemAnswer(index, i, items) {
      this.$set(
        items,
        'itemAnswer' + (i + 1),
        this.$t('pc_biz_ote_lbl_dragquestionsdefault')
      );
      this.$forceUpdate();
    },
    delItemAnswer(index, i, items) {
      const keys = Object.keys(items);
      for (let v = 0; v < keys.length; v++) {
        if (i <= v) {
          if (keys[v + 1] !== undefined) {
            items[keys[v]] = items[keys[v + 1]];
          }
        }
      }

      this.$delete(items, keys[keys.length - 1]);

      this.$forceUpdate();
    },
    // 获取试题基本信息
    getDetail() {
      if (this.$refs['editorItem' + this.index]) {
        try {
          this.$refs['editorItem' + this.index].setHtml(
            this.currentComponent.content
          );
          this.$refs['explainText' + this.index].setHtml(
            this.currentComponent.explainText
          );
        } catch (e) {}
      }
      this.$forceUpdate();
    },
    // 保存试题基本信息
    saveDetail() {
      // 编辑试题
      let isSave = false;
      this.$refs.ruleForm.validate(valid => {
        if (this.currentComponent.itemAnswerObj.length === 0) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_fillinanswernotempty') // 填空题答案不能为空
          });
          return false;
        }
        if (this.currentComponent.itemAnswerObj.length > 12) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_fillinanswer12exceed') // 填空题不能超过12个答案
          });
          return false;
        }

        if (valid) {
          isSave = true;
        } else {
          return false;
        }
      });

      if (!isSave) {
        return { error: true };
      } else {
        this.currentComponent.addBackup = 0;
        this.currentComponent.questionItems =
          this.currentComponent.itemAnswerObj
            .filter(i => i.itemAnswer)
            .map(item => {
              if (
                [
                  item.itemAnswer1,
                  item.itemAnswer2,
                  item.itemAnswer3,
                  item.itemAnswer4,
                  item.itemAnswer5
                ].filter(item2 => item2).length > 0
              ) {
                this.currentComponent.addBackup = 1;
              }
              return {
                id: this.getGuid(),
                itemContent: item.itemAnswer,
                answer: 1,
                alternativeContents: [
                  item.itemAnswer1,
                  item.itemAnswer2,
                  item.itemAnswer3,
                  item.itemAnswer4,
                  item.itemAnswer5
                ].filter(item2 => item2)
              };
            });

        this.currentComponent.summary = getSafeHtmlContent(this.currentComponent.content);

        delete this.currentComponent.fillItems;
        this.currentComponent.error = 0;
        this.currentComponent.errorMsg = '';
        return this.currentComponent;
      }
    },
    // 删除
    delItem(index) {
      this.currentComponent.itemAnswerObj.splice(index, 1);
      this.$forceUpdate();
    },
    // 添加选项
    addItem() {
      if (this.currentComponent.itemAnswerObj.length >= 12) {
        this.$message({
          type: 'warning',
          message: this.$t('pc_biz_ote_msg_choiceitemmax') // 最多可添加12个选项！
        });
        return;
      }
      // 添加选项（单选/多选）
      const questionItem = {
        itemAnswer: this.$t('pc_biz_ote_lbl_dragquestionsdefault')
      };
      this.currentComponent.itemAnswerObj.push(questionItem);

      // focus到最后添加的输入框
      this.$nextTick(() => {
        this.$refs[
          `editorItem_input${this.currentComponent.itemAnswerObj.length - 1}`
        ][0].focus();
        this.$refs[
          `editorItem_input${this.currentComponent.itemAnswerObj.length - 1}`
        ][0].select();
      });
      this.$forceUpdate();
    }
  }
};
</script>
